import qs from 'qs'

export const queryArchivePage = () => {
  const query = qs.stringify(
    {
      fields: ['title'],
      populate: {
        ...queryFragmentSingleTypeDefault,
        ...queryFragmentBlocks,
        introductions: true,
        entries: {
          populate: {
            titles: true,
            subtitles: true,
            descriptions: true,
            images: true
          }
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `archive-page?${query}`
}
